import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const fontSize = '18px'

const StyledAddress = styled.div`
	font-size: ${fontSize};
`

const StyledIncompleteAddress = styled.div`
	display: flex;
	flex-direction: column;
	font-size: ${fontSize};
	justify-content: space-around;

	.message {
		font-size: 2rem;
	}
`

/**
 *
 * @param {object} address
 * the address to show
 */
const SelectedAddress = ({ address }) =>
	isIncompleteAddress(address) ? (
		<IncompleteAddress {...address} />
	) : (
		<CompleteAddress {...address} />
	)

const CompleteAddress = ({
	street,
	number,
	neighborhood,
	zipCode,
	complement,
	city,
	state
}) => (
	<StyledAddress className="address">
		<span className="bold">
			{street} N° {number}
		</span>
		<br />
		{complement} <br />
		{neighborhood} <br />
		{city} - {state} <br />
		CEP {zipCode} <br />
	</StyledAddress>
)

const IncompleteAddress = ({ city, state }) => (
	<StyledIncompleteAddress className="address">
		<span className="bold message">Informe o endereço de cobrança</span>
		<br />
		{city} - {state}
	</StyledIncompleteAddress>
)

const isIncompleteAddress = ({ street, number, neighborhood, zipCode }) =>
	[street, number, neighborhood, zipCode].some(value => value === null)

SelectedAddress.propTypes = {
	address: PropTypes.object.isRequired
}

export default SelectedAddress
